import { useState } from 'react';

let manuallyClosed = false;

export const useCanShowSafeModeSwitchingPopup = () => {
	const [visible, setVisible] = useState(manuallyClosed);

	const setManuallyClosed = () => {
		manuallyClosed = true;
		setVisible(true);
	};

	return { popupVisible: !visible, closePopup: setManuallyClosed };
};
